import { Injectable, Component } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { GlobalVariablesService } from '../global-variables.service';
import { Subject } from 'rxjs';
import { GlobalMethodsService } from '../global-methods.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  public openModalsList = [];
  public isOpeningModal = false;

  constructor(
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public gvs: GlobalVariablesService,
    public gms: GlobalMethodsService,
    public activatedRoute: ActivatedRoute
  ) { }

  public modal: { instance: HTMLIonModalElement; status: boolean } = { instance: null, status: false };

  public async show(component, id, componentProps: { [key: string]: any; }, cssClass: string[]) {
    if(this.modal.instance){
      this.closeAllOpenModals();
    }
      this.isOpeningModal = true;
      this.gms.setMoreComponentEvent(false);
      await this.create(component, id, componentProps, cssClass);

    if (this.modal.status === false && this.modal.instance != null) {
      await this.modal.instance.present();
      this.modal.status = true;
      this.isOpeningModal = false;
      this.openModalsList.push(id);
      return this.modal.instance;
    } else {
      this.isOpeningModal = false;
      return;
    }
  }

  async create(component, id, componentProps: { [key: string]: any; }, cssClass: string[]) {
    const opts = {
      component,
      id,
      componentProps,
      cssClass
    }
    this.modal.instance = await this.modalCtrl.create(opts);
  }

  public hide(modalId, value?) {
    if (this.modal.instance && this.modal.status && !this.isOpeningModal) {
      this.modalCtrl.dismiss({ result: value ? value : false }, '', modalId);
      // await this.modal.instance.dismiss();
    }
    const route: any = this.activatedRoute.snapshot;
    this.gvs.modalLoaded = 'empty';
    this.openModalsList = this.arrayRemove(this.openModalsList, modalId);
    this.modal = { instance: null, status: false };
    if (route._routerState.url === '/home' && this.openModalsList.length === 0) {
      this.gms.setMoreComponentEvent(true);
    }
  }

  public closeAllOpenModals() {
    if (this.openModalsList.length > 0 && !this.isOpeningModal) {
      this.openModalsList.forEach(modal => {
        this.hide(modal);
      });
      this.openModalsList = [];
    }
  }

  public arrayRemove(arr, value) {
    const position = arr.indexOf(value);
    return arr.length > 1 ? arr.splice(position, 1) : arr.splice(position, 0);
  }

  public isModalOpen(modal) {
    return this.openModalsList.indexOf(modal) > -1;
  }

}
